module.exports = __webpack_public_path__ + "img/icon_6.e6c235d9.png";